import { GetRecoilValue } from 'recoil';
import { themeState } from 'components/common/Managers/SettingsManager.state';
import { ComponentsTheme, THEMED_COMPONENT, themes } from './themes';

export const createStylesGetter =
  <Component extends THEMED_COMPONENT, ComponentStyles>(
    prepareStylesForComponent: (styles: ComponentsTheme[Component]) => ComponentStyles,
    component: Component,
  ) =>
  ({ get }: { get: GetRecoilValue }): ComponentStyles => {
    const selectedTheme = get(themeState);
    return prepareStylesForComponent(themes[selectedTheme][component]);
  };
